var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcQuestionCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Question_x5F_circle",
    d: "M15.35,11.177l-0.994,1.016c-0.795,0.796-1.291,1.469-1.291,3.125h-2.209v-0.553 c0-1.226,0.497-2.33,1.292-3.125l1.371-1.392c0.407-0.398,0.651-0.951,0.651-1.558c0-1.227-0.994-2.209-2.209-2.209 c-1.22,0-2.209,0.989-2.209,2.209H7.54c0-2.44,1.978-4.419,4.418-4.419c2.44,0,4.419,1.979,4.419,4.419 C16.378,9.663,15.979,10.536,15.35,11.177 M13.062,19.736h-2.208v-2.209h2.208 M11.958,0.958c-6.101,0-11.047,4.945-11.047,11.046 c0,6.102,4.946,11.047,11.047,11.047c6.103,0,11.046-4.945,11.046-11.047C23.005,5.897,18.034,0.958,11.958,0.958z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuestionCircle);
export default __webpack_public_path__ + "static/media/ic_question_circle.ff3c9554b155ec321ed7702d45b7fb51.svg";
export { ForwardRef as ReactComponent };